import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { Layout, ProtectedRoute, GlobalLoader } from "./components";
import { Login, Profile, TeacherDashboard, TeacherStudents, TeacherAttendance, TeacherContent, TeacherInbox, TeacherArtworks, StudentDashboard, StudentAttendance, ArtworkSubmission, StudentInbox } from "./pages";
import { ROUTES } from "./constants";
import { useAppSelector } from "./redux";
import "./components/common/Toast/Toast.css";

const RootRedirect: React.FC = () => {
  const { isAuthenticated, role } = useAppSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (role === "teacher") {
    return <Navigate to={ROUTES.TEACHER.DASHBOARD} replace />;
  }

  if (role === "student") {
    return <Navigate to={ROUTES.STUDENT.DASHBOARD} replace />;
  }

  return <Navigate to={ROUTES.LOGIN} replace />;
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <GlobalLoader />
      <Toaster position="top-right" reverseOrder={false} />
      <Routes>
        {/* Public Login Route */}
        <Route path={ROUTES.LOGIN} element={<Login />} />

        {/* Protected Portal Routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<RootRedirect />} />

          {/* Teacher Portal */}
          <Route path={ROUTES.TEACHER.ROOT} element={<Layout />}>
            <Route index element={<Navigate to={ROUTES.TEACHER.DASHBOARD} replace />} />
            <Route path="dashboard" element={<TeacherDashboard />} />
            <Route path="students" element={<TeacherStudents />} />
            <Route path="attendance" element={<TeacherAttendance />} />
            <Route path="content" element={<TeacherContent />} />
            <Route path="inbox" element={<TeacherInbox />} />
            <Route path="artworks" element={<TeacherArtworks />} />
            <Route path="profile" element={<Profile />} />
          </Route>

          {/* Student Portal */}
          <Route path={ROUTES.STUDENT.ROOT} element={<Layout />}>
            <Route index element={<Navigate to={ROUTES.STUDENT.DASHBOARD} replace />} />
            <Route path="dashboard" element={<StudentDashboard />} />
            <Route path="attendance" element={<StudentAttendance />} />
            <Route path="inbox" element={<StudentInbox />} />
            <Route path="artwork-submission" element={<ArtworkSubmission />} />
            <Route path="profile" element={<Profile />} />
          </Route>
        </Route>

        {/* Fallback Catch-all Route */}
        <Route path="*" element={<RootRedirect />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
